import { Cell } from './cell';

export class GridElement {
  cells: Cell[] = [];
  get isFull(): boolean {
    return this.cells.every((cell) => cell.currentBlock !== null);
  }

  setGridElementEmpty(): void {
    this.cells.forEach(async (cell, index) => {
      cell.setBlock({ block: null, displayIndex: index });
    });
  }
}
